import { TemplateResult, html } from "lit";
import { getEnumValues } from "../../Utils";
import { BaseElement } from "../BaseElement";
import { renderSelect } from "./Select";

export function renderEnumSelect(
    root: BaseElement,
    enumType: any,
    object: any,
    prop: string,
    label?: string,
    helpMsg?: string,
    filter?: (x: any) => boolean,
    multiple = false,
    maxOptionsVisible = 0,
    onModified = () => {},
    convertToEnum = (v: any) => v,
    convertFromEnum = (v: any) => v,
    displayText?: (v: any) => string
): TemplateResult {
    let values = getEnumValues(enumType);
    if (filter) {
        values = values.filter(filter);
    }

    if (values.length > 1) {
        return renderSelect(
            root,
            values,
            object,
            prop,
            label,
            helpMsg,
            multiple,
            maxOptionsVisible,
            onModified,
            convertToEnum,
            convertFromEnum,
            displayText
        );
    }
    return html``;
}
